// Suppress React 18.3 defaultProps deprecation warnings from third-party libraries
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('Support for defaultProps will be removed') ||
      args[0].includes(
        'findDOMNode is deprecated and will be removed in the next major release'
      ))
  ) {
    return;
  }
  originalError.apply(console, args);
};

import React from 'react';
import { createRoot } from 'react-dom/client';

import NextApp from './NextApp';
import { unregister } from './registerServiceWorker';

// React 18: Use createRoot instead of ReactDOM.render
const container = document.getElementById('root');
const root = createRoot(container);

unregister();

// Render the app
root.render(<NextApp />);
